import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

import { OperatorIconComponent } from '@connect-services/client/components/field-intervention-information/field-intervention-operator-or-status-metrics/field-intervention-operator/operator-icon/operator-icon.component';
import { DashboardInterventionEntityByOperator } from '@connect-services/client/components/field-intervention-information/field-intervention-operator-or-status-metrics/field-intervention-operator-or-status-metrics.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [OperatorIconComponent],
    selector: 'app-field-intervention-operator',
    styleUrl: '../field-intervention-operator-or-status-metrics.component.scss',
    templateUrl: './field-intervention-operator.component.html',
})
export class FieldInterventionOperatorComponent {
    public readonly operator: InputSignal<DashboardInterventionEntityByOperator> =
        input.required<DashboardInterventionEntityByOperator>();
}
